import actions from '@/store/helpCenter/actions';

const helpCenterModule = {
  state: () => ({
    pageHelpCenter: {},
    categoriesList: [],
    helpCenterTemplates: [],
    isLoadingTemplates: false,
  }),
  mutations: {
    GET_HELP_CENTERS_SUCCESS(state, pageHelpCenter) {
      state.pageHelpCenter = pageHelpCenter;
    },
    GET_HELP_CENTERS_CATEGORIES_SUCCESS(state, data) {
      state.categoriesList = data;
    },
  },
  actions,
  namespaced: true,
};

export default helpCenterModule;
